import styles from './SegmentedControl.module.css';

type Option<T extends string> = { value: T; label: string };

type Props<T extends string> = {
  label?: string;
  value: T | null;
  onChange: (next: T) => void;
  options: ReadonlyArray<Option<T>>;
  disabled?: boolean;
};

// Generischer Segmented-Control. `value=null` bedeutet noch keine Auswahl
// (Submit bleibt dann disabled im Parent). Wird sobald geklickt nicht-null.
export function SegmentedControl<T extends string>({
  label,
  value,
  onChange,
  options,
  disabled,
}: Props<T>) {
  return (
    <div className={styles.wrap}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.row} role="radiogroup" aria-label={label}>
        {options.map((o) => {
          const active = value === o.value;
          return (
            <button
              key={o.value}
              type="button"
              role="radio"
              aria-checked={active}
              className={`${styles.seg} ${active ? styles.active : ''}`}
              onClick={() => onChange(o.value)}
              disabled={disabled}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
